import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    // width: 300,
    display: 'flex',
    alignItems: 'center',
    // padding: '0px 24px'
  },
  slider: {
    marginRight: 16
  }
});

function valuetext(value) {
  return `${value}°C`;
}

export default function DiscreteSlider({
  value,
  onChange,
  min,
  max,
  step,
  createCustomUnits,
  disabled
}) {
  const classes = useStyles();

  const handleChange = (e, newValue) => {
    if (newValue === value) return; // Value may not actually change since event fires even on vertical drag
    onChange(newValue);
  }

  const units = createCustomUnits
    ? createCustomUnits(value)
    : Math.round(value * 100) + '%';

  return (
    <div className={classes.root}>
      <Slider
        className={classes.slider}
        value={value}
        onChange={handleChange}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider"
        valueLabelDisplay="off"
        step={step !== undefined ? step : .1}
        marks
        min={min !== undefined ? min : .5}
        max={max !== undefined ? max : 2}
        disabled={disabled}
      />
      <Typography variant='subtitle2'>{units}</Typography>
    </div>
  );
}
